<div class="container default-container results memnberTab office-block">
    <paging [len]="len"
    [page]="page" 
    [config]="config" 
    [totalItems]="totalItems"                
    (changePage)="handleOnChangePage($event)" 
    (totalPage)="onTotalPage($event)"              
    (changeLen)="handleOnChangeSelectedValue($event)" 
    [turnOnTotalPage]="true"               
    [turnOnPagination]="false" 
    [turnOnTotalItem]="true" 
    [isMobile]="true">
   </paging>
    
    <div class="table-container row draggable-element">
        <div class="col col_data">
            <div class="table-wrapper table draggable-items-wrapper tb-scroll-container" draggableWrapper>
                <table class="hr-table"style="display: table">
                    <thead>
                        <tr>
                            <th class="sticky-col" style="white-space: nowrap; text-align: center;">회원번호</th>
                            <th style="white-space: nowrap; text-align: center;">회원명</th>
                            <th style="white-space: nowrap; text-align: center;">본부/센터</th>
                            <th style="white-space: nowrap; text-align: center;">추천인</th>
                            <th style="white-space: nowrap; text-align: center;">합계</th>
                            <th style="white-space: nowrap; text-align: center;">1월</th>
                            <th style="white-space: nowrap; text-align: center;">2월</th>
                            <th style="white-space: nowrap; text-align: center;">3월</th>
                            <th style="white-space: nowrap; text-align: center;">4월</th>
                            <th style="white-space: nowrap; text-align: center;">5월</th>
                            <th style="white-space: nowrap; text-align: center;">6월</th>
                            <th style="white-space: nowrap; text-align: center;">7월</th>
                            <th style="white-space: nowrap; text-align: center;">8월</th>
                            <th style="white-space: nowrap; text-align: center;">9월</th>
                            <th style="white-space: nowrap; text-align: center;">10월</th>
                            <th style="white-space: nowrap; text-align: center;">11월</th>
                            <th style="white-space: nowrap; text-align: center;">12월</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of items | paginate: config">
                            <td class="sticky-col" style="text-align: center;">{{ item.userid }}</td>
                            <td>{{ item.userName }}</td>
                            <td>{{ item.cntName }}</td>
                            <td>{{ item.rname }}({{ item.rid }})</td>
                            <td style="text-align: right;">{{ item.totalPrice | setComma }}{{ showUnit? '원' : '' }}</td>
                            <td style="text-align: right;">{{ item.mon1 | setComma }}{{ showUnit? '원' : '' }}</td>
                            <td style="text-align: right;">{{ item.mon2 | setComma }}{{ showUnit? '원' : '' }}</td>
                            <td style="text-align: right;">{{ item.mon3 | setComma }}{{ showUnit? '원' : '' }}</td>
                            <td style="text-align: right;">{{ item.mon4 | setComma }}{{ showUnit? '원' : '' }}</td>
                            <td style="text-align: right;">{{ item.mon5 | setComma }}{{ showUnit? '원' : '' }}</td>
                            <td style="text-align: right;">{{ item.mon6 | setComma }}{{ showUnit? '원' : '' }}</td>
                            <td style="text-align: right;">{{ item.mon7 | setComma }}{{ showUnit? '원' : '' }}</td>
                            <td style="text-align: right;">{{ item.mon8 | setComma }}{{ showUnit? '원' : '' }}</td>
                            <td style="text-align: right;">{{ item.mon9 | setComma }}{{ showUnit? '원' : '' }}</td>
                            <td style="text-align: right;">{{ item.mon10 | setComma }}{{ showUnit? '원' : '' }}</td>
                            <td style="text-align: right;">{{ item.mon11 | setComma }}{{ showUnit? '원' : '' }}</td>
                            <td style="text-align: right;">{{ item.mon12 | setComma }}{{ showUnit? '원' : '' }}</td>
                        </tr>
                        <ng-container *ngIf="totalRows < 5">
                            <tr *ngFor="let row of rows; index as i">
                                <ng-container *ngFor="let col of cols; index as j">
                                    <td>
                                        <span>&nbsp;</span>
                                        <ng-container *ngIf="totalRows === 0 && i === 2 && j === 7">
                                            <span class='h-small empty-warning'>조회된 데이타가 없습니다.</span>
                                        </ng-container>
                                    </td>
                                </ng-container>
                            </tr>
                        </ng-container>
                    </tbody>
                    <tfoot>
                        <tr *ngIf="sum$ | async as item">
                            <td colspan="4" style="text-align: center;">[합계]</td>
                            <td style="text-align: right;">{{ item.totalPrice | setComma }}{{ showUnit? '원' : '' }}</td>
                            <td style="text-align: right;">{{ item.mon1 | setComma }}{{ showUnit? '원' : '' }}</td>
                            <td style="text-align: right;">{{ item.mon2 | setComma }}{{ showUnit? '원' : '' }}</td>
                            <td style="text-align: right;">{{ item.mon3 | setComma }}{{ showUnit? '원' : '' }}</td>
                            <td style="text-align: right;">{{ item.mon4 | setComma }}{{ showUnit? '원' : '' }}</td>
                            <td style="text-align: right;">{{ item.mon5 | setComma }}{{ showUnit? '원' : '' }}</td>
                            <td style="text-align: right;">{{ item.mon6 | setComma }}{{ showUnit? '원' : '' }}</td>
                            <td style="text-align: right;">{{ item.mon7 | setComma }}{{ showUnit? '원' : '' }}</td>
                            <td style="text-align: right;">{{ item.mon8 | setComma }}{{ showUnit? '원' : '' }}</td>
                            <td style="text-align: right;">{{ item.mon9 | setComma }}{{ showUnit? '원' : '' }}</td>
                            <td style="text-align: right;">{{ item.mon10 | setComma }}{{ showUnit? '원' : '' }}</td>
                            <td style="text-align: right;">{{ item.mon11 | setComma }}{{ showUnit? '원' : '' }}</td>
                            <td style="text-align: right;">{{ item.mon12 | setComma }}{{ showUnit? '원' : '' }}</td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    </div>
   <paging [len]="len"
    [page]="page" 
    [config]="config" 
    [totalItems]="totalItems"                
    (changePage)="handleOnChangePage($event)" 
    (totalPage)="onTotalPage($event)"              
    (changeLen)="handleOnChangeSelectedValue($event)" 
    [turnOnTotalPage]="true"               
    [turnOnPagination]="true" 
    [turnOnTotalItem]="true" 
    [isMobile]="false">
   </paging>
</div>